import React, { Component } from "react";
import {
  MnemoLoading,
  MSection,
} from "components/misc";
import { COMPANY, LABEL_UNIVERSITY, ROUTES } from "const";
import {
  enrollmentEvaluationService,
  networkErrorHelper,
} from "libs";
import { Helmet } from "react-helmet";
import { withRouter } from "react-router-dom";
import {
  Row,
  Col,
  Container,
} from "design-react-kit";
import { MTable } from "components/table";

class CourseInfoPercorsiAbilitanti extends Component {
  _class1Ref = null;

  state = {
    loading: true,
    loadingError: false,
    bandiList: [],

    currentAA: "2025",
    currentEdition: 1,
    currentCompany: "",
  };

  componentDidMount() {
    this.setState({ loading: true, loadingError: false });
    const { company } = this.props.match.params;
    const { currentAA, currentEdition } = this.state;

    //if company not empty and not in LABEL_UNIVERSITY, redirect to 404 page
    if ((company && !LABEL_UNIVERSITY[company]) || company === COMPANY.IUL) {
      this.props.history.push(ROUTES.PAGE_404);
    }

    this.setState({ currentCompany: company });
    this.loadBandi(currentEdition, currentAA, company);
  }

  loadBandi(bandoedition, aa, company) {
    enrollmentEvaluationService
      .bandoEvaluationInfoList(bandoedition, aa, company)
      .then(({ data }) => {
        const bandiList = data.payload.bandiEvaluationInfo;
        this.setState({ bandiList, loading: false });
      })
      .catch((error) => {
        console.log(error);
        networkErrorHelper.notify(error);
        this.setState({ loadingError: true, loading: false });
      });
  }


  renderBandi = () => {

    const { bandiList } = this.state;

    //group bandi by region
    const regions = {};
    bandiList.forEach((item) => {
      const r = item.region;
      if (!regions[r]) regions[r] = [];
      regions[r].push(item);
    });

    const tableConfig = {
      columns: [
        {
          id: "competitionClass",
          Header: "Classe",
          accessor: "competitionClass",
        },
        { id: "title", Header: "Denominazione", accessor: "title" },
        { id: "sitTotal", Header: "Posti", accessor: "sitTotal" },
      ],
    };

    return Object.keys(regions)
      .sort()
      .map((region) => {
        const regionData = regions[region];

        //get region total seats
        const regionSeats = regionData.reduce((sum, item) => {
          return sum + item.sitTotal;
        }, 0);

        const tableData = [
          ...regionData,
          {
            id: `total-${region}`,
            competitionClass: "",
            title: <strong>Totale posti </strong>,
            sitTotal: <strong>{regionSeats}</strong>,
          },
        ];

        return (
          <>
            <div key={region}>
              <h3 className="text-center my-3">{region.toUpperCase()}</h3>
              <MTable tableConfig={tableConfig} tableData={tableData} />
            </div>
          </>
        );
      });
  };

  renderHeader() {
    const title = "Corsi Abilitanti 60 CFU a.a. 2025/2026";
    const { currentCompany } = this.state;

    let logo = "";
    let company = "";

    switch (currentCompany) {
      case COMPANY.UNICAMILLUS:
        logo = "/img/partners/Unicamillus_logo.png";
        company =
          "l'Università Unicamillus - Saint Camillus International University of Health Sciences";
        break;
      case COMPANY.REGGIO:
        logo = "/img/partners/Unidarc_logo.png";
        company =
          "l'Università per Stranieri “Dante Alighieri” di Reggio Calabria";
        break;
      case COMPANY.UNITELMA:
        logo = "/img/partners/Unitelma_logo.png";
        company =
          "l'Università UnitelmaSapienza - Università degli studi di Roma";
        break;
      default:
        logo = "";
        company = "";
    }

    return (
      <>
        <Helmet>
          <title>{title}</title>
          <meta property="og:title" content={title} />
        </Helmet>

        <div>
          <div className="w-100 text-center my-4">
            <img
              className="image-secondary-banner w-50"
              src={logo}
              alt={company}
            />
          </div>
        </div>
        <div>
          <h1>{title}</h1>
          <h2>Percorsi di formazione iniziale per docenti D.Lgs. 59/2017 e D.P.C.M. 4 agosto 2023 (da € 1.880) </h2>
          <p>Il Ministero dell’Università nonché il NDV valutano positivamente oltre 2.000 posti 60 e 30 CFU. Le iscrizioni saranno aperte non appena il MUR stabilirà il contingente Ufficiale!</p>
          <h3>ATTENZIONE</h3>
          <ol><li>Il corso si svolgerà <b>nella stessa regione in cui si presenta la domanda di partecipazione</b>.
            Si evidenzia che alcune Università organizzano i corsi in regioni diverse, anche molto distanti rispetto a quella di residenza o indicata dal corsista, con conseguente obbligo di frequenza in presenza (<b>a posteriori</b>)
            che può comportare spostamenti anche di migliaia di chilometri.</li>
            <li><b>Solo a seguito della definizione del contingente da parte del MUR</b>, le Università regolarmente autorizzate potranno procedere all’apertura delle iscrizioni.</li>
            <li>L’iscrizione e la frequenza ai <b>percorsi abilitanti da noi proposti</b>, erogati da <b>{company}</b>,
              prevedono i seguenti costi:

              {(currentCompany === COMPANY.UNICAMILLUS) && (
                <ul>
                  <li>€ <b>2.500</b> per il percorso da <b>60 CFU</b> (Allegato 1).</li>
                  <li>€ <b>1.900</b> per il percorso da <b>30 CFU</b> (Allegato 2);</li>
                  <li>€ <b>1.900</b> per i percorsi Vincitori di Concorso.</li>
                </ul>)}
              {(currentCompany === COMPANY.REGGIO) && (
                <ul>
                  <li>a partire da € <b>2.380</b> per il percorso da <b>60 CFU</b> (Allegato 1).</li>
                  <li>a partire da € <b>1.880</b> per il percorso da <b>30 CFU</b> (Allegato 2);</li>
                  <li>€ <b>1.900</b> per i percorsi Vincitori di Concorso.</li>
                </ul>)}
            </li>
          </ol>
        </div>
      </>
    );
  }

  render() {
    const { loading } = this.state;

    return (
      <section className="my-4">
        {loading ? (
          <MnemoLoading />
        ) : (
          <>
            <Container>
              <MSection className="mb-3">
                <Row>
                  <Col size="12">{this.renderHeader()}</Col>
                </Row>
              </MSection>
              <MSection className="mb-3">
                <h3>Contingente </h3>
                <Row>
                  <Col size="12">{this.renderBandi()}</Col>
                </Row>
              </MSection>
              <MSection className="mb-3">
                <div>
                  <p>Non è previsto alcun limite di posti nelle suddette regioni per i vincitori di concorso che abbiano partecipato con:</p>
                  <p>a) tre anni di servizio (anche ITP);</p>
                  <p>b) 30 CFU non abilitanti propedeutici al concorso;</p>
                  <p>Interessante sapere.....</p>
                  <h3>1. Percorsi abilitanti per accedere alla I fascia GPS e/o al Concorso</h3>
                  <div class="table-wrap">
                    <table class="MTable table  table-striped table-hover" role="table">
                      <thead>
                        <tr>
                          <th>Situazione</th>
                          <th>Percorso previsto</th>
                          <th>CFU</th>
                          <th>Note</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td>Non abilitato e senza 24 CFU</td>
                          <td>Percorso abilitante ordinario</td>
                          <td>60 CFU</td>
                          <td>Iscrizioni ATTIVE non appena il MUR autorizzerà TUTTE le Università</td>
                        </tr>
                        <tr>
                          <td>Non abilitato ma con 24 CFU</td>
                          <td>Percorso abilitante ordinario ma con CFU ridotti</td>
                          <td>60 CFU</td>
                          <td>Iscrizioni ATTIVE non appena il MUR autorizzerà TUTTE le Università
                            NB: ai 60 CFU dovranno essere decurtati
                            i CFU riconosciuti nei 24 CFU</td>
                        </tr>
                        <tr>
                          <td>Non abilitato ma con almeno 3 anni di servizio o contratto nei percorsi IeFP</td>
                          <td>Percorso abilitante ridotto</td>
                          <td>30 CFU</td>
                          <td>Riservati 45% dei posti del percorso ordinario;
                            Iscrizioni ATTIVE non appena il MUR autorizzerà TUTTE le Università</td>
                        </tr>
                        <tr>
                          <td>Già abilitato o specializzato sul sostegno</td>
                          <td>Percorso per seconda abilitazione</td>
                          <td>30 CFU (online)</td>
                          <td>Disponibile su
                            <a href="https://www.formazionedocenti.it/60cfu-30cfu-abilitazione-insegnamento" target="_blank" rel="noopener noreferrer">https://www.formazionedocenti.it/60cfu-30cfu-abilitazione-insegnamento</a>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                  <h3>2. Percorsi post-concorso (per vincitori di concorso)</h3>
                  <div class="table-wrap">
                    <table class="MTable table  table-striped table-hover" role="table">
                      <thead>
                        <tr>
                          <th>Situazione del vincitore</th>
                          <th>Percorso post-concorso</th>
                          <th>CFU</th>
                          <th>Note</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td>Ha partecipato con tre anni di servizio (anche ITP)</td>
                          <td>Percorso di completamento</td>
                          <td>30 CFU</td>
                          <td>Senza limite di posti</td>
                        </tr>
                        <tr>
                          <td>Ha partecipato con 30 CFU non abilitanti propedeutici al concorso</td>
                          <td>Percorso di completamento</td>
                          <td>30 CFU</td>
                          <td>Senza limite di posti</td>
                        </tr>
                        <tr>
                          <td>Ha partecipato con 24 CFU</td>
                          <td>Percorso di completamento</td>
                          <td>36 CFU</td>
                          <td>Senza limite di posti</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                  <h2>Sintesi finale</h2>
                  <ul>
                    <li>Chi non è ancora abilitato deve svolgere un percorso abilitante con accesso a numero programmato da 60, 36 o 30 CFU, in base ai titoli posseduti.</li>
                    <li>Chi ha già vinto il concorso, ma non è ancora abilitato, deve completare la formazione con un percorso post-concorso da 30 o 36 CFU con accesso a numero non limitato.</li>
                    <li>Chi è già abilitato o specializzato può conseguire un’altra abilitazione con un percorso da 30 CFU (online) con accesso a numero non limitato e già disponibile su:
                      <a href="https://www.formazionedocenti.it/60cfu-30cfu-abilitazione-insegnamento" target="_blank" rel="noopener noreferrer">https://www.formazionedocenti.it/60cfu-30cfu-abilitazione-insegnamento</a>
                    </li>
                  </ul>
                  <p><a href="https://www.formazionedocenti.it/assets/doc/REGISTRO_UFFICIALE_2025_0019116.pdf" target="_blank" rel="noopener noreferrer"> Decreto Ministeriale su accreditamento corsi 60 CFU a.a. 2025/2026</a></p>
                </div>
              </MSection>
            </Container>
          </>
        )}
        <hr />
        <hr />
        <p>
          E-mail:{" "}
          <a href="mailto:abilitazione@formazionedocenti.it">
            abilitazione@formazionedocenti.it
          </a>
        </p>
      </section>
    );
  }
}

export default withRouter(CourseInfoPercorsiAbilitanti);